import {
  api_url,
  legendLabelsBoxHeightLine,
  configChartsColorPalettes,
  yRight,
  partSumpTrajectory,
  popupInformation,
  defaultDatalabelsAlign,
  defaultDatalabelsAnchor,
  defaultDatalabelsFontWeight,
  defaultTicksCustomValue,
} from "../../../utils";

const VoiesPrioritairesPietons = {
  checked: false,
  titleSideBar: "Vías con prioridad peatonal",
  titleIndicator:
    "SUMP Trajectory Content.charts.VoiesPrioritairesPietons.title",
  popupInformation: {
    status: "false",
    text: popupInformation[partSumpTrajectory]["voiesPrioritairesPietons"],
  },
  keyFigure: {
    typeUpdate: "geographical_area", // year or geographical_area
    label: "",
    url: "",
    separator: "",
    position: "",
  },
  charts: [
    {
      typeChart: "bar",
      typeLabels: "years", // years or geographical_areas
      multiYearGeographicalArea: true,
      singleYearGeographicalAreaType: "year", // year or geographical_area : MUST BE CONSISTENT WITH THE TYPE_LABEL ARGUMENT OF THE DATASET URL
      titleChart: "",
      titleDisplay: "true",
      legendDisplay: "true",
      legendCustom: "false",
      legendLabelsBoxHeight: legendLabelsBoxHeightLine,
      maintainAspectRatio: true,
      indexAxis: "x", // x or y
      heightChart: "340",
      widthChart: "400",
      scales: {
        x: {
          type: "category",
          display: true,
          stacked: false,
          titleDisplay: false,
          titleText: "",
          gridDisplay: false,
          min: null,
          beginAtZero: false,
          ticks: {
            display: true,
            value: defaultTicksCustomValue,
          },
        },
        y: {
          type: "linear",
          display: true,
          stacked: false,
          titleDisplay: true,
          titleText:
            "SUMP Trajectory Content.charts.VoiesPrioritairesPietons.axis.titleY",
          gridDisplay: true,
          beginAtZero: true,
          max: 60,
          ticks: {
            display: true,
            value: {
              prefix: "",
              suffix: "",
            },
          },
        },
        yRight: yRight,
      },
      annotationsProperties: {
        annotation1: {
          type: "line",
          xMin: undefined,
          xMax: undefined,
          yMin: 28.0,
          yMax: 28.0,
          borderColor: "rgb(74, 214, 141)",
          borderDash: [7, 7],
          borderWidth: 3,
        },
        annotation2: {
          type: "line",
          xMin: undefined,
          xMax: undefined,
          yMin: 41.0,
          yMax: 41.0,
          borderColor: "rgb(39, 171, 102)",
          borderDash: [7, 7],
          borderWidth: 3,
        },
      },
      keyFigure: {
        typeUpdate: "geographical_area", // year or geographical_area
        label: "",
        url: "",
        separator: "",
        position: "",
      },
      datasets: [
        {
          type: "line",
          label:
            "SUMP Trajectory Content.charts.VoiesPrioritairesPietons.legend.Valeur cible 2034",
          data: [],
          url:
            api_url +
            "charts/data/?part=sump-trajectory&type_label=cusco_years&indicator=voies_prioritaires_pietons&trend=projection&chart=voies_prioritaires_pietons_valeur_cible_2034&chart_data=True&indicator_key_figure=False&schema_city=",
          backgroundColor:
            configChartsColorPalettes[
              "trajectory_target_value_2034_voies_prioritaires_pietons"
            ].backgroundColor["0"],
          borderColor:
            configChartsColorPalettes[
              "trajectory_target_value_2034_voies_prioritaires_pietons"
            ].borderColor["0"],
          borderWidth: 4,
          borderDash: [7, 7],
          pointStyle: "circle",
          pointRadius: 0,
          spanGaps: true,
          legendCustomCssClass: "",
          fill: false,
          yAxisID: "y",
          order: 2,
          tooltipUnit: "",
          barPercentage: 1,
          categoryPercentage: 1,
          datalabelsProperties: {
            display: false,
            anchor: defaultDatalabelsAnchor,
            align: defaultDatalabelsAlign,
            font: {
              weight: defaultDatalabelsFontWeight,
            },
            value: {
              prefix: "",
              suffix: "",
              separator: "",
            },
          },
        },
        {
          type: "line",
          label:
            "SUMP Trajectory Content.charts.VoiesPrioritairesPietons.legend.Valeur cible 2044",
          data: [],
          url:
            api_url +
            "charts/data/?part=sump-trajectory&type_label=cusco_years&indicator=voies_prioritaires_pietons&trend=projection&chart=voies_prioritaires_pietons_valeur_cible_2044&chart_data=True&indicator_key_figure=False&schema_city=",
          backgroundColor:
            configChartsColorPalettes[
              "trajectory_target_value_2044_voies_prioritaires_pietons"
            ].backgroundColor["0"],
          borderColor:
            configChartsColorPalettes[
              "trajectory_target_value_2044_voies_prioritaires_pietons"
            ].borderColor["0"],
          borderWidth: 4,
          borderDash: [7, 7],
          pointStyle: "circle",
          pointRadius: 0,
          spanGaps: true,
          legendCustomCssClass: "",
          fill: false,
          yAxisID: "y",
          order: 2,
          tooltipUnit: "",
          barPercentage: 1,
          categoryPercentage: 1,
          datalabelsProperties: {
            display: false,
            anchor: defaultDatalabelsAnchor,
            align: defaultDatalabelsAlign,
            font: {
              weight: defaultDatalabelsFontWeight,
            },
            value: {
              prefix: "",
              suffix: "",
              separator: "",
            },
          },
        },
        {
          type: "bar",
          label:
            "SUMP Trajectory Content.charts.VoiesPrioritairesPietons.legend.Voies",
          data: [],
          url:
            api_url +
            "charts/data/?part=sump-trajectory&type_label=cusco_years&indicator=voies_prioritaires_pietons&trend=projection&chart=voies_prioritaires_pietons&chart_data=True&indicator_key_figure=False&schema_city=",
          backgroundColor:
            configChartsColorPalettes[
              "trajectory_target_value_2024_voies_prioritaires_pietons"
            ].backgroundColor["0"],
          borderColor:
            configChartsColorPalettes[
              "trajectory_target_value_2024_voies_prioritaires_pietons"
            ].borderColor["0"],
          borderWidth: 2,
          pointStyle: "circle",
          pointRadius: 3,
          spanGaps: true,
          legendCustomCssClass: "",
          fill: false,
          yAxisID: "y",
          order: 3,
          tooltipUnit: "",
          tooltipToReplace: {
            "SUMP Trajectory Content.charts.VoiesPrioritairesPietons.legend.Voies":
              "SUMP Trajectory Content.charts.VoiesPrioritairesPietons.legend.Voies Popup",
          },
          barPercentage: 0.8,
          categoryPercentage: 0.4,
          datalabelsProperties: {
            display: false,
            anchor: defaultDatalabelsAnchor,
            align: defaultDatalabelsAlign,
            font: {
              weight: defaultDatalabelsFontWeight,
            },
            value: {
              prefix: "",
              suffix: "",
              separator: "",
            },
          },
        },
      ],
    },
  ],
};

export default VoiesPrioritairesPietons;
